var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#111928"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50197 11.4695C10.897 11.4695 12.0445 10.367 12.0445 8.99453C12.0445 7.62203 10.897 6.51953 9.50197 6.51953C8.10697 6.51953 6.95947 7.62203 6.95947 8.99453C6.95947 10.367 8.10697 11.4695 9.50197 11.4695Z",
    fill: "#111928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1498 12.5484C16.3648 12.5484 17.3323 11.6034 17.3323 10.4109C17.3323 9.21844 16.3423 8.27344 15.1498 8.27344C13.9573 8.27344 12.9673 9.21844 12.9673 10.4109C12.9673 11.6034 13.9573 12.5484 15.1498 12.5484Z",
    fill: "#111928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2621 12.7748H15.0596C14.3846 12.7748 13.7321 12.9773 13.1696 13.3148C12.5621 12.5048 11.5946 11.9648 10.5146 11.9648H8.51209C6.66709 11.9873 5.20459 13.4498 5.20459 15.2723V16.8923C5.20459 17.3198 5.54209 17.6573 5.96959 17.6573H18.0521C18.4796 17.6573 18.8396 17.2973 18.8396 16.8698V16.3298C18.8171 14.3723 17.2196 12.7748 15.2621 12.7748Z",
    fill: "#111928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupReporting);
export default __webpack_public_path__ + "static/media/group-reporting.52f57a55cd7ce3b79ff035ab5024500b.svg";
export { ForwardRef as ReactComponent };